// ===== 共用：上傳到 OneDrive =====
window.ndUploadToOneDrive = async function ndUploadToOneDrive(fileOrBlob, subpath, filename) {
  const URL_UPLOAD = "https://nd-onedrive-uploader-2.vercel.app/apps/nd-upload/upload";
  if (!fileOrBlob) throw new Error("fileOrBlob 不可為空");
  if (!filename) throw new Error("filename 必須指定");

  const fd = new FormData();
  fd.append("file", fileOrBlob, filename);
  fd.append("subpath", String(subpath || "").replace(/^\/+/, ""));
  fd.append("filename", filename);

  const r = await fetch(URL_UPLOAD, {
    method: "POST",
    mode: "cors",
    credentials: "omit",
    headers: { "Accept": "application/json" }, // 別自己設 Content-Type
    body: fd
  });

  let js = null; try { js = await r.json(); } catch {}
  if (!r.ok || !js?.ok) {
    const msg = js?.error || `HTTP ${r.status}`;
    console.error("[OneDrive Upload ERROR]", r.status, msg, js);
    throw new Error(msg);
  }
  console.log("[OneDrive Upload OK]", js);
  return js.item; // Graph 檔案資訊
};
